import React, { useEffect, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { Close } from '@components/icons'
import { ButtonRounded, WModal } from '@components/atoms'
import styles from './RivenditoreMapModal.module.sass'
import {
  RivenditoreCardBody,
  RivenditoreCardHead,
} from '../RivenditoreCardContent/RivenditoreCardContent'
import { RES_MD_MIN } from '@utils/settings'

interface Props {
  rivenditore?: any
  open?: boolean
  onClose?: () => void
  className?: string
}

const RivenditoreMapModal = (props: Props) => {
  const { rivenditore = undefined, open = false, onClose = undefined, className = '' } = props

  const t = useTrans()
  const [mobile, setMobile] = useState(false)

  const getContent = () =>
    !!rivenditore ? (
      <>
        <div className={styles.head}>
          <RivenditoreCardHead rivenditore={rivenditore} />
          {!!onClose && (
            <ButtonRounded
              icon={<Close />}
              onClick={onClose}
              className={styles.close}
              ariaLabel={t('Chiudi')}
              size="xs"
              theme="neutral20"
            />
          )}
        </div>
        <RivenditoreCardBody rivenditore={rivenditore} />
      </>
    ) : (
      <></>
    )

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth < RES_MD_MIN)
      if (window.innerWidth >= RES_MD_MIN) document.body.classList.remove('w-noscroll')
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return mobile ? (
    <WModal
      id={`rivenditoremapmodal`}
      open={open}
      onClose={onClose}
      className={`${styles.root} ${className}`}
    >
      {getContent()}
    </WModal>
  ) : (
    <div className={`${styles.root} ${open ? styles['root--open'] : ''} ${className}`}>
      {getContent()}
    </div>
  )
}

export default RivenditoreMapModal
